<template>
  <address-form
    :value="value"
    :address-details-value="addressDetailsValue"
    :field="field"
    :disabled="disabled"
    :label="label"
    :show-alias="false"
    :show-private-toggle="true"
    :show-searchable-toggle="false"
    :hide-name-when-private="true"
    :clear-name-when-private="true"
    v-on="$listeners"
  />
</template>

<script>
import AddressForm from '@/views/orders/partials/AddressForm.vue'

export default {
  name: 'PartnerAddressForm',
  components: {
    AddressForm,
  },
  props: {
    value: {
      type: [Object, Number],
      default: null,
    },
    addressDetailsValue: {
      type: Number,
      default: null,
    },
    field: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
}
</script>
